export default __webpack_public_path__ + "static/site-banner-a1653ee58286ce20b47fb2a8f5d9d501.jpg";